import * as React from "react";

const Loading: React.FC<{}> = () => {
	return (
		<div className="text-center p-5">
			<div className="spinner-border" role="status">
				<span className="visually-hidden">Loading...</span>
			</div>
			<p>Loading...</p>
		</div>
	);
};

export default Loading;
